import { FC } from "react"
import './cardCustomer.css'
import { UserIcon } from "../MenuIcons/UserIcon"
import { cpfMask } from "../../functions/mask"

type Customer = {
    name: string
    email: string
    cpf: string
    show?: boolean
}

const CardCustomer: FC<Customer> = ({ email, name, cpf,show }) => {
    return (
        <div className="cardCustomerContent">
            { !show &&
                <div className="icon">
                    <UserIcon />
                </div>
            }
            <div className="infoCardCustomer">
                <div className="name">
                    <span>{name}</span>
                </div>
                <div className="cpf">
                    <span>CPF: {cpfMask(cpf)}</span>
                </div>
                <div className="email">
                    <span>Email: {email}</span>
                </div>
            </div>
        </div>
    )
}

export { CardCustomer }